export default __webpack_public_path__ + "static/media/x market black 1.635c1134.svg";